<script lang="ts">
    import {createEventDispatcher} from 'svelte';
    import {pipe} from '../../svelte/utils';
    import KpValueEditor from '../../commons/value-editors/kp-value-editor/KpValueEditor.svelte';
    import {loc} from '../../svelte/pipes';
    import type {EditableFieldType} from '../../typings/portaro.be.types';
    import {ValueEditorSize} from '../../commons/value-editors/types';
    import type {SingleAcceptableValueEditorOptions} from '../../commons/value-editors/editors/single-acceptable/types';

    export let addableFieldTypes: EditableFieldType[] = [];
    export let localizedText = '';
    export let size = ValueEditorSize.MD;

    const dispatch = createEventDispatcher<{'add-field': EditableFieldType}>();

    let editorOptions: SingleAcceptableValueEditorOptions<EditableFieldType>;
    $: editorOptions = {
        acceptableValues: addableFieldTypes,
        switchToInlineModeThreshold: 1
    }

    let typeToAdd = null;

    function addEmptyField(field: EditableFieldType) {
        dispatch('add-field', field);
        typeToAdd = null;
    }
</script>

<template>
    {#if addableFieldTypes.length > 1}
        <KpValueEditor type={'single-acceptable'}
                       bind:model={typeToAdd}
                       placeholder={localizedText}
                       options={editorOptions}
                       {size}
                       on:model-change={(event) => addEmptyField(event.detail)}/>
    {/if}
    {#if addableFieldTypes.length === 1}
        <button class="btn btn-default btn-block btn-{size}" on:click={() => addEmptyField(addableFieldTypes[0])}>
            <span class="glyphicon glyphicon-plus" aria-hidden="true"></span>
            {localizedText} {pipe(addableFieldTypes[0], loc())}
        </button>
    {/if}
</template>